import { render, staticRenderFns } from "./Possessions.vue?vue&type=template&id=f32b4b44&"
import script from "./Possessions.vue?vue&type=script&lang=js&"
export * from "./Possessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports